import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CtaBanner({ title, text, testId }) {
  return (
    <section className="grain relative overflow-hidden bg-ink">
      <svg className="airflow absolute inset-0 h-full w-full opacity-25" viewBox="0 0 1200 400" preserveAspectRatio="none" aria-hidden="true">
        <path d="M-50 90 C 300 40, 700 150, 1260 80" stroke="#38BDF8" strokeWidth="1.5" fill="none" />
        <path d="M-50 210 C 350 160, 750 260, 1260 190" stroke="#00A8E8" strokeWidth="1.5" fill="none" />
        <path d="M-50 330 C 280 280, 720 370, 1260 300" stroke="#38BDF8" strokeWidth="1.5" fill="none" />
      </svg>
      <div className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-300">Get in touch</p>
          <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{text}</p>
          <Link
            to="/contact"
            data-testid={testId}
            className="mt-9 inline-flex items-center gap-2.5 rounded-md bg-brand px-7 py-3.5 font-semibold text-white shadow-lg shadow-brand/25 transition-all hover:bg-sky-400 active:scale-[0.98]"
          >
            Make an Enquiry
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
